<template>
    <v-container class="full-height pa-0" fluid>
        <v-sheet border rounded class="wrapper">
            <div class="outline-text pa-2" style="font-size: 2em">
                <v-row no-gutters>
                    <v-col>
                        FLU - CNC PART FOR LOC-185 - CNC SMASG2-0004 (BLANK TOP)
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                    <v-col> 23-067 SMASHBOX FY24 CONVERSION LOCAT </v-col>
                </v-row>
            </div>

            <v-row>
                <v-col>
                    <v-card class="custom-card">
                        <v-row class="activeEmployee pa-2" no-gutters>
                            <v-col> 0 Active Employee </v-col>
                        </v-row>
                        <v-row class="info outline-text" no-gutters>
                            <v-col>
                                <v-row no-gutters class="jobBarLabel"
                                    ><v-col>Job #</v-col></v-row
                                >
                                <v-row no-gutters class="jobBarInfo"
                                    ><v-col>23-067/FL195R</v-col></v-row
                                >
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col>
                                <v-row no-gutters class="jobBarLabel"
                                    ><v-col>ASM Seq</v-col></v-row
                                >
                                <v-row no-gutters class="jobBarInfo"
                                    ><v-col>2</v-col></v-row
                                >
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col>
                                <v-row no-gutters class="jobBarLabel"
                                    ><v-col>OPE Seq</v-col></v-row
                                >
                                <v-row no-gutters class="jobBarInfo"
                                    ><v-col>10</v-col></v-row
                                >
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col>
                                <v-row no-gutters class="jobBarLabel"
                                    ><v-col>MTL #</v-col></v-row
                                >
                                <v-row no-gutters class="jobBarInfo"
                                    ><v-col>10</v-col></v-row
                                >
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col>
                                <v-row> <v-col>Part</v-col> </v-row>
                                <div class="text-center" style="padding: 35px">
                                    <v-row class="boldNum">
                                        <v-col>SMASG2-L610</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            >FLU - CNC PART FOR LOC-185 - CNC
                                            SMASG2-0004 (BLANK TOP)</v-col
                                        >
                                    </v-row>
                                </div>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col>
                                <v-row><v-col>Material</v-col></v-row>
                                <div class="text-center" style="padding: 35px">
                                    <v-row class="boldNum"
                                        ><v-col>SMAS02-0050</v-col></v-row
                                    >
                                    <v-row>
                                        <v-col>SMALL BLACK MOLDED COVER.</v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="ordered pa-2" no-gutters>
                            <v-col> MATERIAL ORDERED </v-col>
                        </v-row>
                        <v-row class="text-center" no-gutters>
                            <v-col>
                                <v-row class="quantity outline-text" no-gutters
                                    ><v-col>Run Quantity</v-col></v-row
                                >
                                <v-row
                                    ><v-col>
                                        <div class="quantityNum">80</div>
                                    </v-col></v-row
                                >
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col>
                                <v-row class="quantity outline-text" no-gutters
                                    ><v-col>Run Quantity</v-col></v-row
                                >
                                <v-row
                                    ><v-col>
                                        <div
                                            class="quantityNum"
                                            style="color: #dc3545"
                                        >
                                            80
                                        </div>
                                    </v-col></v-row
                                >
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>

                <v-col cols="3" class="text-center">
                    <v-row no-gutters class="button-group">
                        <v-col cols="6" class="button-column">
                            <button class="button">
                                <div class="button-content">
                                    <i class="mdi mdi-information mdi-64px"></i>
                                    <div class="button-label">Job Info</div>
                                </div>
                            </button>
                        </v-col>
                        <v-col cols="6" class="button-column">
                            <button class="button">
                                <div class="button-content">
                                    <i class="mdi mdi-download mdi-64px"></i>
                                    <div class="button-label">Request</div>
                                </div>
                            </button>
                        </v-col>
                        <v-col cols="6" class="button-column">
                            <button class="button">
                                <div class="button-content">
                                    <i class="mdi mdi-history mdi-64px"></i>
                                    <div class="button-label">
                                        Labor History
                                    </div>
                                </div>
                            </button>
                        </v-col>
                        <v-col cols="6" class="button-column">
                            <button class="button">
                                <div class="button-content">
                                    <i class="mdi mdi-backburger mdi-64px"></i>
                                    <div class="button-label">Back</div>
                                </div>
                            </button>
                        </v-col>
                        <v-col cols="6" class="button-column">
                            <button class="button">
                                <div class="button-content">
                                    <i class="mdi mdi-camera mdi-64px"></i>
                                    <div class="button-label">Part Photo</div>
                                </div>
                            </button>
                        </v-col>
                        <v-col cols="6" class="button-column">
                            <button class="button">
                                <div class="button-content">
                                    <i class="mdi mdi-printer mdi-64px"></i>
                                    <div class="button-label">Print Label</div>
                                </div>
                            </button>
                        </v-col>
                        <v-col class="button-column">
                            <button class="button" style="background: #90ee90">
                                <div class="button-content">
                                    <i class="mdi mdi-login mdi-64px"></i>
                                    <div
                                        class="button-label"
                                        style="background: #73be73"
                                    >
                                        Clock In
                                    </div>
                                </div>
                            </button>
                        </v-col>
                        <v-col v-if="clockedIn" class="button-column">
                            <button class="button" style="background: #ffc0cb">
                                <div class="button-content">
                                    <i class="mdi mdi-logout mdi-64px"></i>
                                    <div
                                        class="button-label"
                                        style="background: #cc9aa2"
                                    >
                                        Stop
                                    </div>
                                </div>
                            </button>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-sheet>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            activeButton: null,
            clockedIn: true,
        };
    },
    methods: {
        setActiveButton(button) {
            this.activeButton = button;
            setTimeout(() => {
                this.activeButton = null;
            }, 100);
        },
    },
};
</script>
<style lang="css" scoped>
.full-height {
    height: 100vh;
    width: 100%;
}
.wrapper {
    background-color: #facd90;
}
.activeEmployee {
    background-color: lightgray;
    font-size: 1.5em;
}
.info {
    background-color: #6c757d;
    text-align: center;
}
.ordered {
    background-color: #fff8be;
}
.quantity {
    background-color: #007bff;
    text-align: center;
    padding: 5px;
}
.quantityNum {
    font-size: 6em;
    padding: 30px;
    font-weight: bold;
    font-family: system-ui;
}
.jobBarLabel {
    font-size: 0.75em;
}
.jobBarInfo {
    font-weight: bold;
    font-size: 1.5em;
}
.outline-text {
    color: white;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
        1px 1px 0 #000;
}
.boldNum {
    font-weight: bold;
    font-size: 1.5em;
}
.mdi-64px {
    font-size: 64px;
}
.button {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: flex-end;
    background: white;
    border: 1px solid black;
    border-radius: 4px;
}
.button-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
}
.button-content i {
    align-self: center;
}
.button-label {
    font-size: 1.5em;
    font-weight: bold;
    font-family: system-ui;
    width: 100%;
    background: lightgrey;
}
/* .button-group {
    height: 100%;
} */
.button-column {
    display: flex;
    align-items: stretch;
}
.button:active {
    background-color: lightgrey !important;
}
</style>
